/**
 *
 *  Booking Flow Panel Header
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 20/03/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// Icons
import CloseIcon from "../../../icons/CloseIcon";

// Utils
import { getPartnerPictureUrl } from "../../../utils";

import defaultPartnerPhoto from "../../../images/generic-trainerphoto.svg";

const BookingFlowPanelHeader = ({
  isOnline,
  partnerSummary,
  partnerLoaded,
  onClose,
}) => (
  <div className="booking-flow-panel-header tbk--ml-2 tbk--mr-2 tbk-flex tbk-border-b tbk-border-solid tbk-border-[#e3e7eb] tbk-px-2 tbk-pb-2">
    <button
      className="tbk-absolute tbk-right-2 tbk-text-coral"
      onClick={onClose}
    >
      <CloseIcon />
    </button>
    <Link to={`/partners/${partnerSummary && partnerSummary.id}`}>
      <div className={`tb-profile-picture tbk-mr-1.5`}>
        <img
          className="tbk-top-0 tbk-h-6 tbk-w-6 tbk-rounded-lg tbk-object-cover"
          itemProp="image"
          src={
            partnerLoaded
              ? getPartnerPictureUrl(partnerSummary)
              : defaultPartnerPhoto
          }
          alt={`${
            partnerSummary
              ? partnerSummary.firstName + " " + partnerSummary.lastName
              : ""
          } | Personal Trainer in Los Angeles`}
        />
      </div>
    </Link>
    <div>
      {partnerLoaded ? (
        <Link
          to={`/partners/${partnerSummary.id}`}
          className="tbk-text-h3-subtitle tbk-mb-1.5 tbk-inline-block tbk-text-grey-main"
        >
          {partnerSummary.firstName}
        </Link>
      ) : (
        <div className="tbk-mb-1.5 tbk-h-[30px] tbk-w-8 tbk-animate-flash tbk-rounded-lg tbk-bg-blue-grey-light" />
      )}
      <div className="tbk-text-small-bold tb-vertical-alignment-fix tbk-uppercase tbk-text-blue-grey">
        {isOnline ? "Online" : "In-Person"}
      </div>
    </div>
  </div>
);

BookingFlowPanelHeader.propTypes = {
  isOnline: PropTypes.bool,
  partnerSummary: PropTypes.object,
  partnerLoaded: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

BookingFlowPanelHeader.defaultProps = {
  isOnline: false,
};

export default BookingFlowPanelHeader;
